/* ------------------------------------------------------------------
 * Mojito Styling Ideas — PDP "complete the look" bundle controller (3-tile)
 * ------------------------------------------------------------------
 *  - Relocates the widget into the buy-box (.form__wrapper), below the
 *    trust-badge block — additive, no edits to the core product section.
 *  - Left = the stacked outfit (current product + top/bottom partner).
 *    Right = an optional "elevate" tile (suit / capsule).
 *  - Colour swatches (built from each product's Colour option) swap the
 *    chosen variant + main image + price. Size stays a small <select>.
 *  - Tile 1 mirrors the PDP's currently selected variant (live).
 *  - The outfit (2 pieces) is pre-selected; the elevate piece is an optional
 *    toggle, so one dynamic CTA covers both "add both" and "add all 3".
 *  - "Add" posts all selected variants in one /cart/add.js, then refreshes +
 *    opens the cart drawer via the theme's own getCart()/openCartDrawer().
 *
 *  No real discount is applied here (a theme can't set line prices); every
 *  line carries properties[_styling_bundle] + _rec_source + _bundle_role so a
 *  future Shopify discount/Function can target the bundle and you can track it.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(cents / 100).toLocaleString('en-US');
    if (/\{\{\s*amount\s*\}\}/.test(fmt)) return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(fmt)) return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec);
    return '$' + amount;
  }

  // Update text WITHOUT a childList mutation. mojito-pdp-native.js runs a
  // MutationObserver on product-info's subtree ({childList:true}); our widget lives
  // inside it, so any added/removed node re-triggers that script's gallery refresh →
  // setActiveThumb → scrollIntoView, which scrolls the page (~120-350ms later). Setting
  // .textContent replaces the text node (childList); mutating the existing text node's
  // .data is a characterData change, which that observer does not watch.
  function setText(el, str) {
    if (!el) return;
    var s = String(str);
    if (el.childNodes.length === 1 && el.firstChild.nodeType === 3) {
      if (el.firstChild.data !== s) el.firstChild.data = s;
    } else {
      el.textContent = s;
    }
  }

  function readVariants(tile) {
    var s = tile ? tile.querySelector('[data-si-variants]') : null;
    if (!s) return [];
    try { return JSON.parse(s.textContent); } catch (e) { return []; }
  }

  function pdpForm() {
    return document.querySelector('form[action*="/cart/add"][data-product-form]:not([data-quickbuy-form])');
  }

  function initWidget(root) {
    if (root.dataset.siInit) return;
    root.dataset.siInit = '1';

    var currentTile = root.querySelector('.msi-tile--current');
    var currentVariants = readVariants(currentTile);

    var totalEl = root.querySelector('[data-si-total]');
    var countLabel = root.querySelector('[data-si-count-label]');
    var addBtn = root.querySelector('[data-si-add]');
    var addLabel = root.querySelector('[data-si-add-label]');
    var errEl = root.querySelector('[data-si-error]');
    var elevateToggleBtn = root.querySelector('[data-si-elevate-toggle]');
    var toggleLabel = root.querySelector('[data-si-toggle-label]');
    var elevateIncluded = false;
    var showSavings = root.getAttribute('data-si-show-savings') === '1';
    // Storefront-locale strings (rendered by the section from locales/*.json).
    var i18n = (function () {
      var d = { count_one: 'Bundle · 1 item', count_other: 'Bundle · %COUNT% items', add: 'Add %COUNT% to cart', added: 'Added — %PRICE%', add_it: 'Add it — +%PRICE%', choose: 'Please choose options for the items.', error: 'Could not add to cart. Please try again.' };
      try { var p = JSON.parse(root.getAttribute('data-si-i18n') || '{}'); Object.keys(p).forEach(function (k) { if (p[k]) d[k] = p[k]; }); } catch (e) { /* keep defaults */ }
      return d;
    })();

    // Bundle discount tiers — mirror the Complete the Look function's settings,
    // rendered into data-si-tier-config by the section from the synced shop
    // metafield. Clamped here too, and falling back to the function's built-in
    // 10% / 5% / $100 so a missing/garbled config can never break the widget.
    // Shopify floors the discount amount to the cent, so do the same.
    var tierCfg = (function () {
      var cfg = { high: 10, low: 5, thresholdCents: 10000 };
      try {
        var p = JSON.parse(root.getAttribute('data-si-tier-config') || '{}');
        if (isFinite(p.high)) cfg.high = Math.min(100, Math.max(0, Number(p.high)));
        if (isFinite(p.low)) cfg.low = Math.min(100, Math.max(0, Number(p.low)));
        if (isFinite(p.thresholdCents) && Number(p.thresholdCents) >= 0) cfg.thresholdCents = Number(p.thresholdCents);
      } catch (e) { /* keep defaults */ }
      return cfg;
    })();
    function tierPct(cents) { return cents >= tierCfg.thresholdCents ? tierCfg.high : tierCfg.low; }
    function discCents(cents) { return cents - Math.floor(cents * tierPct(cents) / 100); }

    // Paint a tile's price block: when this line will actually be discounted by the
    // Function, show the discounted price + struck original; otherwise the plain price.
    function paintTilePrice(tile, cents, discounted) {
      if (!tile) return;
      var wrap = tile.querySelector('[data-si-price]');
      var cur = tile.querySelector('[data-si-price-current]');
      var was = tile.querySelector('[data-si-price-was]');
      var show = discounted && showSavings && discCents(cents) < cents;
      if (cur) setText(cur, formatMoney(show ? discCents(cents) : cents));
      if (was) { if (show) { setText(was, formatMoney(cents)); was.hidden = false; } else { was.hidden = true; } }
      if (wrap) wrap.classList.toggle('msi-tile__price--bundled', show);
    }
    function activePartnerCurated() {
      var t = carousels.partner ? activeTile(carousels.partner) : null;
      return !!(t && t.getAttribute('data-si-curated') === '1');
    }

    // ---------- carousels (partner + elevate) ----------
    var carousels = {};
    qsa(root, '[data-si-carousel]').forEach(function (slot) {
      var name = slot.getAttribute('data-si-carousel');
      var options = qsa(slot, '.msi-options > [data-si-tile]');
      var c = { slot: slot, name: name, options: options, prev: slot.querySelector('[data-si-prev]'), next: slot.querySelector('[data-si-next]'), idx: 0 };
      carousels[name] = c;
      if (options.length <= 1) slot.classList.add('msi-single');
      if (c.prev) c.prev.addEventListener('click', function () { showOption(c, c.idx - 1); });
      if (c.next) c.next.addEventListener('click', function () { showOption(c, c.idx + 1); });
    });
    function activeTile(c) { return c && c.options.length ? c.options[c.idx] : null; }

    // ---------- tile 1 (mirrors the PDP variant) ----------
    function currentVariantId() {
      var f = pdpForm();
      var input = f ? f.querySelector('[name="id"]') : null;
      var id = input ? parseInt(input.value, 10) : NaN;
      if (id) return id;
      var hidden = currentTile && currentTile.querySelector('[data-si-current-variant]');
      return hidden ? parseInt(hidden.value, 10) : null;
    }
    function currentInfo() {
      var id = currentVariantId();
      var v = currentVariants.filter(function (x) { return x.id === id; })[0];
      var price = v ? v.price : (function () {
        var p = currentTile && currentTile.querySelector('[data-si-price-cents]');
        return p ? parseInt(p.getAttribute('data-si-price-cents'), 10) : 0;
      })();
      return { role: 'current', id: id, price: price, available: v ? v.available : true };
    }
    function syncCurrentTile() {
      var info = currentInfo();
      var hidden = currentTile && currentTile.querySelector('[data-si-current-variant]');
      if (hidden && info.id) hidden.value = info.id;
      var v = currentVariants.filter(function (x) { return x.id === info.id; })[0];
      if (v && currentTile && v.img) {
        var img = currentTile.querySelector('[data-si-main-img]'); if (img) img.src = v.img;
      }
      updateBundle();
    }

    // ---------- resolve a suggestion tile from swatch + selects ----------
    function resolveVariant(tile) {
      if (!tile) return;
      var variants = readVariants(tile);
      if (!variants.length) return;
      var colorIdx = parseInt(tile.getAttribute('data-si-color-index'), 10);
      var optCount = variants[0].opts.length;

      var want = [];
      for (var i = 0; i < optCount; i++) {
        var val = null;
        if (i === colorIdx) {
          var act = tile.querySelector('[data-si-swatch].is-active');
          val = act ? act.getAttribute('data-si-value') : null;
        } else {
          var sel = tile.querySelector('[data-si-select][data-si-option-index="' + i + '"]');
          if (sel) val = sel.value;
        }
        want.push(val);
      }

      function matches(v, strict) {
        return v.opts.length === want.length && v.opts.every(function (o, idx) {
          if (want[idx] === null) return true;
          if (!strict && colorIdx >= 0 && idx !== colorIdx) return true; // relax non-colour
          return o === want[idx];
        });
      }

      var chosen = variants.filter(function (v) { return matches(v, true); })[0];
      if (!chosen) {
        var pool = variants.filter(function (v) { return matches(v, false); });
        chosen = pool.filter(function (v) { return v.available; })[0] || pool[0] || variants[0];
      }

      // reflect the chosen variant back into the size select(s)
      for (var j = 0; j < optCount; j++) {
        if (j === colorIdx) continue;
        var s2 = tile.querySelector('[data-si-select][data-si-option-index="' + j + '"]');
        if (s2 && chosen.opts[j] != null) s2.value = chosen.opts[j];
      }

      var hidden = tile.querySelector('[data-si-variant-id]');
      var priceWrap = tile.querySelector('[data-si-price-cents]');
      if (hidden) hidden.value = chosen.id;
      if (priceWrap) priceWrap.setAttribute('data-si-price-cents', chosen.price);
      paintTilePrice(tile, chosen.price, tile.getAttribute('data-si-curated') === '1');
      if (chosen.img) { var img = tile.querySelector('[data-si-main-img]'); if (img) img.src = chosen.img; }
      tile.dataset.siUnavailable = chosen.available ? '' : '1';
      updateBundle();
    }

    function tileInfo(tile) {
      if (!tile) return null;
      var hidden = tile.querySelector('[data-si-variant-id]');
      var id = hidden ? parseInt(hidden.value, 10) : null;
      var v = readVariants(tile).filter(function (x) { return x.id === id; })[0];
      var price = v ? v.price : (function () {
        var p = tile.querySelector('[data-si-price-cents]');
        return p ? parseInt(p.getAttribute('data-si-price-cents'), 10) : 0;
      })();
      return {
        role: tile.getAttribute('data-si-role') || 'partner',
        id: id,
        price: price,
        available: v ? v.available : tile.dataset.siUnavailable !== '1',
        handle: tile.getAttribute('data-si-handle')
      };
    }

    // Toggle the "more colours" fade + chevron when the swatch row overflows.
    function updateSwatchScroll(tile) {
      if (!tile) return;
      var wrap = tile.querySelector('.msi-swatches-wrap');
      if (!wrap) return;
      var sc = wrap.querySelector('[data-si-swatches]');
      if (!sc) return;
      var more = (sc.scrollWidth - sc.clientWidth) > 2;
      var atEnd = (sc.scrollLeft + sc.clientWidth) >= (sc.scrollWidth - 2);
      wrap.classList.toggle('msi-has-more', more);
      wrap.classList.toggle('msi-at-end', more && atEnd);
    }

    function showOption(c, idx) {
      if (!c.options.length) return;
      c.idx = Math.max(0, Math.min(idx, c.options.length - 1));
      c.options.forEach(function (o, i) { o.classList.toggle('msi-hidden', i !== c.idx); });
      if (c.prev) c.prev.disabled = c.idx === 0;
      if (c.next) c.next.disabled = c.idx === c.options.length - 1;
      resolveVariant(activeTile(c));
      updateSwatchScroll(activeTile(c));
    }

    // ---------- bundle state ----------
    function updateBundle() {
      var elevate = carousels.elevate ? tileInfo(activeTile(carousels.elevate)) : null;
      if (elevate && !elevate.available) elevateIncluded = false;
      if (elevateToggleBtn) {
        elevateToggleBtn.setAttribute('aria-pressed', elevateIncluded ? 'true' : 'false');
        elevateToggleBtn.disabled = !(elevate && elevate.available);
      }

      var cur = currentInfo();
      var partner = carousels.partner ? tileInfo(activeTile(carousels.partner)) : null;
      // The Function discounts the curated pair: the hero + partner are both discounted
      // only when the active partner is one of the hero's styling_with picks.
      var pairDiscounted = activePartnerCurated();
      cur.discounted = pairDiscounted;
      if (partner) partner.discounted = pairDiscounted;
      if (elevate) elevate.discounted = false; // never in styling_with -> never discounted

      // keep the hero tile's price in sync with the active partner
      paintTilePrice(currentTile, cur.price, cur.discounted);

      var items = [cur];
      if (partner) items.push(partner);
      if (elevate && elevateIncluded) items.push(elevate);

      var valid = items.filter(function (it) { return it && it.id; });
      var count = valid.length;
      var total = valid.reduce(function (s, it) { return s + (it.price || 0); }, 0);
      var discTotal = valid.reduce(function (s, it) { return s + (it.discounted ? discCents(it.price || 0) : (it.price || 0)); }, 0);
      var saving = total - discTotal;

      if (totalEl) { totalEl.setAttribute('data-si-total-cents', total); setText(totalEl, formatMoney(discTotal)); }
      var wasEl = root.querySelector('[data-si-total-was]');
      if (wasEl) { if (showSavings && saving > 0) { setText(wasEl, formatMoney(total)); wasEl.hidden = false; } else { wasEl.hidden = true; } }
      if (countLabel) setText(countLabel, (count === 1 ? i18n.count_one : i18n.count_other).replace('%COUNT%', count));
      if (addLabel) setText(addLabel, i18n.add.replace('%COUNT%', count));
      if (toggleLabel && elevate) {
        setText(toggleLabel, elevateIncluded ? i18n.added.replace('%PRICE%', formatMoney(elevate.price)) : i18n.add_it.replace('%PRICE%', formatMoney(elevate.price)));
      }

      // require the outfit (current + partner) to be available
      var required = [cur];
      if (partner) required.push(partner);
      var ok = required.every(function (it) { return it && it.id && it.available; });
      if (addBtn) addBtn.disabled = !ok;

      root._siItems = valid;
    }

    // ---------- interactions ----------
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-si-swatch]');
      if (!sw) return;
      var tile = sw.closest('[data-si-tile]');
      qsa(tile, '[data-si-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
      resolveVariant(tile);
    });
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-si-select]');
      if (sel) resolveVariant(sel.closest('[data-si-tile]'));
    });

    // swatch-row scroll hint (capture phase — scroll events don't bubble)
    root.addEventListener('scroll', function (e) {
      var sc = e.target;
      if (sc && sc.nodeType === 1 && sc.hasAttribute && sc.hasAttribute('data-si-swatches')) {
        updateSwatchScroll(sc.closest('[data-si-tile]'));
      }
    }, true);
    window.addEventListener('resize', function () {
      qsa(root, '[data-si-tile]:not(.msi-hidden)').forEach(updateSwatchScroll);
    });

    if (elevateToggleBtn) elevateToggleBtn.addEventListener('click', function () {
      if (elevateToggleBtn.disabled) return;
      elevateIncluded = !elevateIncluded;
      updateBundle();
    });

    function showError(msg) {
      if (!errEl) return;
      setText(errEl, msg);
      errEl.hidden = false;
      setTimeout(function () { errEl.hidden = true; }, 4000);
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var items = (root._siItems || []).filter(function (it) { return it.id; });
      if (items.length < 2) { showError(i18n.choose); return; }

      var bundleId = 'si-' + Date.now();
      var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items.map(function (it) {
            return { id: it.id, quantity: 1, properties: { _styling_bundle: bundleId, _rec_source: 'pdp-style-guide', _bundle_role: it.role } };
          })
        })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
        .then(function () {
          addBtn.classList.remove('is-loading');
          updateBundle();
          var drawer = document.querySelector('[data-cart-drawer]') || document.getElementById('cart-drawer');
          if (drawer && typeof drawer.getCart === 'function') {
            drawer.getCart();
            if (typeof drawer.openCartDrawer === 'function') drawer.openCartDrawer();
            document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
          } else {
            window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading');
          updateBundle();
          showError((err && err.description) || i18n.error);
        });
    });

    // keep tile 1 synced with PDP variant changes
    document.addEventListener('theme:product-info:loaded', syncCurrentTile);
    var f = pdpForm();
    if (f) f.addEventListener('change', function () { setTimeout(syncCurrentTile, 0); });

    // initial state
    Object.keys(carousels).forEach(function (n) { showOption(carousels[n], 0); });
    syncCurrentTile();
    updateBundle();
    qsa(root, '[data-si-tile]:not(.msi-hidden)').forEach(updateSwatchScroll);
    setTimeout(function () { qsa(root, '[data-si-tile]:not(.msi-hidden)').forEach(updateSwatchScroll); }, 150);
  }

  function relocate(root) {
    var form = document.querySelector('.product-single__details .form__wrapper') ||
               document.querySelector('.form__wrapper');
    if (form && root.parentNode !== form) form.appendChild(root);
    root.classList.remove('msi-prerelocate');
  }

  function init() {
    qsa(document, '[data-styling-ideas]').forEach(function (root) {
      relocate(root);
      initWidget(root);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();